const pattern = /(([a-zA-Z0-9\-?\.?]+)@(([a-zA-Z0-9\-_]+\.)+)([a-z]{2,3}))+$/
//email validation
export const isValidEmail = (email) => new RegExp(pattern).test(email)
